import React, { useState, useRef, useEffect, useContext } from 'react';
import { IonContent, IonHeader, IonTitle, IonToolbar, IonItem, IonList, IonSplitPane, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonSlides } from '@ionic/react';
import { IonTabs, IonTabBar, IonTabButton, IonText, IonLabel, IonFooter, IonSlide, IonImg, IonRouterOutlet } from '@ionic/react';
import { Redirect} from 'react-router-dom';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import { EnterPasswordModal } from '../../../zInternal_Features/merchant/components/Modal_EnterPassword';
import { CreateInventoryProductModal } from './Modal_CreateInventoryProduct_proService';
import { CreateInventoryItemModal } from './Modal_CreateInventoryItem_proService';


import '../../../css/layout.css';


export function Tab_Management_Inventory () {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [employeeID, setEmployeeID] = useState(authenticatedMerchent_context.employeeID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);


    let [add_to_productModal, setAdd_to_productModal] = useState(false);
    let [stockInventoryProductModal_online, setStockInventoryProductModal_online] = useState(false);
    let [stockInventoryProductModal_onSite, setStockInventoryProductModal_onSite] = useState(false);

    let [createInventoryItemModal, setCreateInventoryItemModal] = useState(false);
    let [stockInventoryItemModal, setStockInventoryItemModal] = useState(false);
    let [deleteInventoryItemModal, setDeleteInventoryItemModal] = useState(false);
    let [adminPasswordCreateInventoryItemModal, setAdminPasswordCreateInventoryItemModal] = useState(false);
    let [adminPasswordDeleteItemModal, setAdminPasswordDeleteItemModal] = useState(false);

    let [productSalePrice, setProductSalePrice] = useState(null);

    let [productPicsModal, setProductPicsModal] = useState(false);

    let [selectedFile, seteSlectedFile] = useState(null);

    let [viewProductDetailsData, setViewProductDetailsData] = useState([]);
    let [viewProductItemsDetailsData, setViewProductItemsDetailsData] = useState([]);

    let [viewItemDetailsData, setViewItemDetailsData] = useState([]);

    let [quantityAddedToProduct, setQuantityAddedToProduct] = useState(null);
    let [quantityReplenishedStock, setQuantityReplenishedStock] = useState(null);

    let [inventoryAccessCheckboxValue, setInventoryAccessCheckboxValue] = useState(null);

    let [productID, setProductID] = useState(null);

    let [storefront, setStorefront] = useState(null);
    let [itemID, setItemID] = useState(null);
    let [itemName, setItemName] = useState(null);
    let [itemDescription, setItemDescription] = useState(null);
    let [vendorPartNum, setVendorPartNum] = useState(null);
    let [vendorName, setVendorName] = useState(null);
    let [vendorPhoneNumber, setVendorPhoneNumber] = useState(null);
    let [vendorAddress, setVendorAddress] = useState(null);
    let [vendorCity, setVendorCity] = useState(null);
    let [vendorCountry, setVendorCountry] = useState(null);
    let [costPerUnit, setCostPerUnit] = useState(null);
    let [qtyInStock, setQtyInStock] = useState(null);
    let [qtyInUse, setQtyInUse] = useState(null);
    let [dateCreated, setDateCreated] = useState(null);
    let [attachment, setAttachment] = useState(null);
    let [addedBy, setAddedBy] = useState(null);

    let [createdByEmployee, setCreatedByEmployee] = useState(null);


    let [viewInventoryProductMainDetailsData, setViewInventoryProductMainDetailsData] = useState([]);
    let [viewInventoryItemMainDetailsData, setViewInventoryItemMainDetailsData] = useState([]);

    let [searchInventoryItem, setSearchInventoryItem] = useState(null);
    let [enterAdminPassword, setEnterAdminPassword] = useState(null);
    let [showProdcutPics, setShowProductPics] = useState(false);
    let [showItemDetails, setShowItemDetails] = useState(false);
    let [activateProductButton, setActivateProductButton] = useState('inline-block');
    let [deactivateProductButton, setDeactivateProductButton] = useState('inline-block');

    let [passwordCategory, setPasswordCategory] = useState(null);
    let [showPasswordModal, setShowPasswordModal] = useState(false);

    let [searchResults, setSearchResults] = useState([]);

    let productItemNameRef = useRef('');
    let itemNameRef = useRef('');

    function handleEnterAdminPassword(e) {   setEnterAdminPassword(e.target.value);    }




    function updateDeleteInventoryItemModal(event) {

        if(event)
        {
            setDeleteInventoryItemModal(event);
        }
        else
        {
            setDeleteInventoryItemModal(event);
            setViewItemDetailsData([]);
        }

    }

    function handleQuantityAddedToProduct(e) {

        setQuantityAddedToProduct(e.target.value);

    }

    function handleQuantityReplenish(e) {

        setQuantityReplenishedStock(e.target.value);

    }

    function handleInventoryAccessCheckbox(checkbox) {


        if(checkbox.checked === true){
            document.getElementById("submit").removeAttribute("disabled");

            setInventoryAccessCheckboxValue("y");

        }
        else{
            document.getElementById("submit").setAttribute("disabled", "disabled");
            setInventoryAccessCheckboxValue("n");
       }
    }


    function updateEnterAdminPasswordDeleteItemModal(event) {

        setAdminPasswordCreateInventoryItemModal(event);
        setDeleteInventoryItemModal(false);
    }

    function saveUploadedFile(event) {
    
        //alert(event);
        
        if(event.target.files === null)
        {
            seteSlectedFile("/var/www/web/Public/fileServer/merchants/image-not-available.jpg")
        }
        else
        {
            seteSlectedFile(event.target.files[0]);

        }


    }


    function searchList(event)
    {
        let searchCategory = event[0];
        let searchData = event[1];

        first_searchSuppliersInDB(searchCategory, searchData);

    }

    function first_searchSuppliersInDB(searchCategory, searchData, optionsData)
    {

        let formData = new FormData();
        let Tracker = '';

        //alert('Inside search Product category');
        //alert(searchCategory);
        //alert(searchData);

        /*if(searchCategory === 'name')
        {

            Tracker = '74002S_N';
        }
        else if(searchCategory === 'phone')
        {
            Tracker = '74002S_P';

        }*/

        if(searchCategory === 'stock_item')
        {

            Tracker = '74302_stock_item';
        }
        else if(searchCategory === 'delete_stock_item')
        {

            Tracker = '74304_delete_stock_item';

        }


        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: Tracker,
                user: acctID,
                xInventorySearchItem: searchData,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

                        let rows = res.toString().split('~~~');

                        let rowLength = rows.length;

                            for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                            {
                                let cols = rows[rownum].split('|');

                                setSearchResults((prevSearchResults) => {
                                    return prevSearchResults.concat({
                                        db_itemId: cols[0],
                                        db_itemName: cols[1],
                                        db_itemDescription: cols[2],
                                        db_vendorPartNumber: cols[3],
                                        db_vendorName: cols[4],
                                        db_vendorPhoneNumber: cols[5],
                                        db_vendorAddress: cols[6],
                                        db_vendorCity: cols[7],
                                        db_vendorCountry: cols[8],
                                        db_costPerUnit: cols[9],
                                        db_qtyInStock: cols[10],
                                        db_qtyInUse: cols[101],
                                        db_dateCreated: cols[12],
                                        db_attachment: cols[13],

                                    })
                                });


                            
                                if(searchCategory === 'delete_stock_item')
                                {
                                    setViewItemDetailsData([]);
                    
                                    getItemDetailData(cols[0]);   
                                    document.getElementById('deleteItemGrid').style.display = 'inline-block';
                                }
                            }

                    })
        }

    function stockProductItems_online(event)
    {


        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //body: JSON.stringify({formData})
            body: JSON.stringify({
                Tracker: '74303_retail',
                user: acctID,
                xInventoryProductID: productID,
                xInventoryItemID: event,
                xInventoryItemAddedToProduct: quantityAddedToProduct,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
        })
        .catch(error => {
            console.error(error);
        })

        setStockInventoryProductModal_online(false);
    }

    function stockProductItems_onSite(event)
    {


        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //body: JSON.stringify({formData})
            body: JSON.stringify({
                Tracker: '74303_retail',
                user: acctID,
                xInventoryProductID: productID,
                xInventoryItemID: event,
                xInventoryItemAddedToProduct: quantityAddedToProduct,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
        })
        .catch(error => {
            console.error(error);
        })

        setStockInventoryProductModal_onSite(false);
    }


    function replenishStock()
    {

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //body: JSON.stringify({formData})
            body: JSON.stringify({
                Tracker: '72303_retail',
                user: acctID,
                xInventoryItemID: itemID,
                xInventoryReplenishStock: quantityReplenishedStock,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
        })
        .catch(error => {
            console.error(error);
        })

        setAdd_to_productModal(false);
    }

function getDataItemMain() {
            
    const requestOptions = {
        method: 'POST',
        //credentials: 'include',
        headers: {
            'Accept': 'text/html, application/json',
            'content-type': 'application/json',
            //'cookie': 'cookie',
        },
        body: JSON.stringify({
            Tracker: '74401_retail',
            user: acctID,
            sessionID: sessionID,
        }),
    }

    
    fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
    .then(res => res.text())
    .then(res => {

        let rows = res.toString().split('~~~');

        for (let rownum = 0; rownum < rows.length - 1; ++rownum)
        {
            let cols = rows[rownum].split('|');


            setViewInventoryItemMainDetailsData((prevViewInventoryItemMainDetailsData) => {
                return prevViewInventoryItemMainDetailsData.concat({
                    itemID: cols[0],
                    itemName: cols[1],
                    itemDescription: cols[2],
                    vendorPartNum: cols[3],
                    vendorName: cols[4],
                    vendorPhoneNumber: cols[5],
                    vendorAddress: cols[6],
                    vendorCity: cols[7],
                    vendorCountry: cols[8],
                    costPerUnit: parseFloat(cols[9]).toFixed(2),
                    qtyInStock: cols[10],
                    qtyInUse: cols[11],
                    dateCreated: cols[12],
                    attachment: cols[13],
                    addedBy: cols[14],
                })
            });

        } 
    })
}


    function getItemDetailData(itemID) {

        //alert('In getEmployeeDetailData');
        //alert(acctID);
        //alert(employeeID);

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74408_retail',
                user: acctID,
                xInventoryItemID: itemID,
                sessionID: sessionID,
            }),
        }
        
        fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            let rows = res.toString().split('~~~');

            for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            {
                let cols = rows[rownum].split('|');

                setViewItemDetailsData((prevViewItemDetailsData) => {
                    return prevViewItemDetailsData.concat({
                        itemID: cols[0],
                        itemName: cols[1],
                        vendorPartNum: cols[2],
                        vendorName: cols[3],
                        costPerUnit: parseFloat(cols[4]).toFixed(2),
                        qtyInStock: cols[5],
                        qtyInUse: cols[6],
                        dateReplenished: cols[7],
                    })
                });
            } 
        })
    }

    function deleteItem()
    {

        /*
        let formData = new FormData();
        formData.append('Tracker', 74499);
        formData.append('user', acctID);
        formData.append('xInventoryItemID', itemID);
        formData.append('xEnterAdminPassword', enterAdminPassword);

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //body: JSON.stringify({formData})
            body: JSON.stringify({
                Tracker: '74499_retail',
                user: acctID,
                xInventoryItemID: itemID,
                xEnterAdminPassword: enterAdminPassword,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
        })
        .catch(error => {
            console.error(error);
        })

        setDeleteInventoryItemModal(false);
        setAdminPasswordCreateInventoryItemModal(false);

    }

let timeout;

function handleInput(event) {


    document.getElementById('searchInventoryProduct_StockProductItemsList').innerHTML = '';


    //document.getElementById('searchInventoryItem_StockItemList').innerHTML = '';

    //alert('Inside handel input 3');
    //alert(event);

    clearTimeout(timeout); // Clear the previous timeout to reset the delay
    timeout = setTimeout(searchList(event), 2000); // Set a new timeout

}

function handle_add_to_product(event)
{

    alert('In Add to Product');
    alert(event);

    setStorefront(event[1]);
    setItemID(event[2]);
    setItemName(event[3]);
    setItemDescription(event[4]);
    setVendorPartNum(event[5]);
    setVendorName(event[6]);
    setVendorPhoneNumber(event[7]);
    setVendorAddress(event[8]);
    setVendorCity(event[9]);
    setVendorCountry(event[10]);
    setCostPerUnit(event[11]);
    setQtyInStock(event[12]);
    setQtyInUse(event[13]);
    setDateCreated(event[14]);
    setAttachment(event[15]);
    setAddedBy(event[16]);
    setAdd_to_productModal(event[0]);
}

function handleSelection() {

    setViewItemDetailsData([]);

    const selectedItemName = productItemNameRef.current.value;
    const selectedItem = searchResults.find(result => result.db_itemName === selectedItemName);
  
    if (selectedItem) {
      // Execute your function here using selectedItem.db_itemId
      getItemDetailData(selectedItem.db_itemId);
    }
}


function setShowPasswordModalHandler(event)
{
    setPasswordCategory(event[1]);
    setShowPasswordModal(event[0]);

}

function onSubmitPasswordHandler()
{

    alert(passwordCategory);

    if(passwordCategory == 'delete-r')
    {
        deleteItem();
    }
    else if(passwordCategory == 'replenish-s')
    {
        alert("Inside Repleshis-s");

        replenishStock();
    }
}


useEffect(() =>  {
        
        getDataItemMain();   

}, [])

//alert('In Management _ Inventory');
//alert(acctID);
//alert(authenticatedMerchent_context.accessRights[0]);
//alert(authenticatedMerchent_context.device);

        return (

            <React.Fragment>

            <IonContent className='grid_content'>
                <IonSlides>
                    <IonSlide>
                    <IonContent className='grid_content_slide'>

                        <div id='inventoryItemOverviewGrid' style={{display: 'inline-block'}}>
                                <IonText> Retail Items </IonText>

                                <IonGrid class='gridText'>
                                        <IonRow >
                                                <IonCol >Item ID</IonCol>
                                                <IonCol >Item Name</IonCol>
                                                {/*<IonCol >Vendor Part Number</IonCol>*/}
                                                {/*<IonCol >Vendor Name</IonCol>*/}
                                                <IonCol >Cost per Unit</IonCol>
                                                <IonCol >Qty InStock</IonCol>
                                                <IonCol >Qty InUse</IonCol>
                                                {/*<IonCol >Date Replenished</IonCol>*/}
                                                {/*<IonCol >Added By</IonCol>*/}
                                                <IonCol >Action</IonCol>
                                        </IonRow>
                                        {viewInventoryItemMainDetailsData.map((detailData) =>   {
                                            return (
                                                <IonRow >
                                                    <IonCol >{detailData.itemID}</IonCol>
                                                    <IonCol >{detailData.itemName}</IonCol>
                                                    {/*<IonCol >{detailData.vendorPartNum}</IonCol>*/}
                                                    {/*<IonCol >{detailData.vendorName}</IonCol>*/}
                                                    <IonCol >{detailData.costPerUnit}</IonCol>
                                                    <IonCol >{detailData.qtyInStock}</IonCol>
                                                    <IonCol >{detailData.qtyInUse}</IonCol>
                                                    {/*<IonCol >{detailData.dateReplenished}</IonCol>*/}
                                                    {/*<IonCol >{detailData.addedBy}</IonCol>*/}
                                                    <IonCol >
                                                        <IonButton  onClick={() => handle_add_to_product([true, 'online',detailData.itemID, detailData.itemName, detailData.itemDescription, detailData.vendorPartNum, detailData.vendorName, detailData.vendorPhoneNumber, detailData.vendorAddress, detailData.vendorCity, detailData.vendorCountry, detailData.costPerUnit, detailData.qtyInStock, detailData.qtyInUse, detailData.dateCreated, detailData.attachment, detailData.createdByEmployee])}> Add-To-Online</IonButton>
                                                        <IonButton  onClick={() => handle_add_to_product([true, 'onsite',detailData.itemID, detailData.itemName, detailData.itemDescription, detailData.vendorPartNum, detailData.vendorName, detailData.vendorPhoneNumber, detailData.vendorAddress, detailData.vendorCity, detailData.vendorCountry, detailData.costPerUnit, detailData.qtyInStock, detailData.qtyInUse, detailData.dateCreated, detailData.attachment, detailData.createdByEmployee])}> Add-To-On-site </IonButton>
                                                        <IonButton  onClick={() => setShowItemDetails(true)}>Cancel </IonButton>
                                                    </IonCol>
                                                </IonRow>
                                            )
                                        }
                                        )}
                                </IonGrid>
                            <IonButton onClick={() => setCreateInventoryItemModal(true)}>Create Item </IonButton>
                            <IonButton onClick={() => setStockInventoryItemModal(true)}>Replenish </IonButton>
                            <IonButton onClick={() => updateDeleteInventoryItemModal(true)}>Delete Item </IonButton>
                        </div>
                        </IonContent>
                    </IonSlide>
                </IonSlides>


                {add_to_productModal == true && <CreateInventoryProductModal openModal={ add_to_productModal } closeModal={() => setAdd_to_productModal(false)} data={{
                                                storefront: storefront,
                                                itemID: itemID,
                                                itemName: itemName,
                                                itemDescription: itemDescription,
                                                vendorPartNum: vendorPartNum,
                                                vendorName: vendorName,
                                                vendorPhoneNumber: vendorPhoneNumber,
                                                vendorAddress: vendorAddress,
                                                vendorCity: vendorCity,
                                                vendorCountry: vendorCountry,
                                                costPerUnit: costPerUnit,
                                                qtyInStock: qtyInStock,
                                                qtyInUse: qtyInUse,
                                                dateCreated: dateCreated,
                                                attachment: attachment,
                                                addedBy: addedBy,
                                            }}></CreateInventoryProductModal>}

                <CreateInventoryItemModal openModal={ createInventoryItemModal } closeModal={() => setCreateInventoryItemModal(false)}></CreateInventoryItemModal>

                <IonModal id='showItemDetails' isOpen={ showItemDetails}>
                        <IonHeader>
                            <IonGrid >
                                <IonRow>
                                            <IonCol >Item ID</IonCol>
                                            <IonCol >Date Created</IonCol>
                                </IonRow>
                                {viewProductDetailsData.map((detailData) =>   {
                                    return (
                                        <IonRow >
                                            <IonCol >{detailData.productID}</IonCol>
                                            <IonCol >{detailData.productDateCreated}</IonCol>
                                        </IonRow>
                                    )
                                }
                                )}
                                <IonRow>
                                    <IonCol size='6'>
                                        <h4>Details</h4>
                                    </IonCol>
                                    <IonCol size='6'>
                                        <h4>Stock Items</h4>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonHeader>
                        <IonContent className='occupiedDetails_gridContent'>
                        <IonGrid>
                            <IonRow>
                                <IonCol>
                                    <IonSlides>
                                        <IonSlide>
                                        {viewProductDetailsData.map((detailData) =>   {
                                            return (
                                            <IonGrid >
                                                <IonRow >
                                                    <IonCol >Category</IonCol>
                                                    <IonCol >Value</IonCol>
                                                    <IonCol >Action</IonCol>
                                                </IonRow>
                                                <IonRow >
                                                    <IonCol >Type</IonCol>
                                                    <IonCol >{detailData.productType}</IonCol>
                                                    <IonCol >
                                                        <IonButton > Update </IonButton>
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow >
                                                    <IonCol >Description</IonCol>
                                                    <IonCol >{detailData.productDescription}</IonCol>
                                                    <IonCol >
                                                        <IonButton > Update </IonButton>
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow >
                                                    <IonCol >Part Number</IonCol>
                                                    <IonCol >{detailData.productPartNum}</IonCol>
                                                    <IonCol >
                                                        <IonButton > Update </IonButton>
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow >
                                                    <IonCol >Phone Number</IonCol>
                                                    <IonCol >{detailData.productPhoneNumber}</IonCol>
                                                    <IonCol >
                                                        <IonButton > Update </IonButton>
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow >
                                                    <IonCol >Address</IonCol>
                                                    <IonCol >{detailData.productAddress}</IonCol>
                                                    <IonCol >
                                                        <IonButton > Update </IonButton>
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow >
                                                    <IonCol >City</IonCol>
                                                    <IonCol >{detailData.productCity}</IonCol>
                                                    <IonCol >
                                                        <IonButton > Update </IonButton>
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow >
                                                    <IonCol >Country</IonCol>
                                                    <IonCol >{detailData.productCountry}</IonCol>
                                                    <IonCol >
                                                        <IonButton > Update </IonButton>
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow >
                                                    <IonCol >Cost Per Unit</IonCol>
                                                    <IonCol >{detailData.productCostPerUnit}</IonCol>
                                                    <IonCol >
                                                        <IonButton > Update </IonButton>
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow >
                                                    <IonCol >Sale Price</IonCol>
                                                    <IonCol >{detailData.productSalePrice}</IonCol>
                                                    <IonCol >
                                                        <IonButton > Update </IonButton>
                                                    </IonCol>
                                                </IonRow>
                                            </IonGrid>
                                                    )
                                                }
                                            )}
                                            </IonSlide>
                                        </IonSlides>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                            </IonContent>
                            <IonButton className='button_closeModal_center' onClick={() => setShowItemDetails(false)}>Cancel </IonButton>
                </IonModal>

                <IonModal id='stockInventoryProductModal_online' isOpen={ stockInventoryProductModal_online}>
                        <IonHeader>

                            <IonGrid >
                                <IonRow>
                                    <IonCol>
                                        <label for='searchInventoryProduct_StockProductItems'>Search Inventory Item for Hotel Product:</label>
                                        <input type='text' id='searchInventoryProduct_StockProductItems' ref={ productItemNameRef } placeholder='Search Product Item' onInput={() => handleInput(['stock_product_item', productItemNameRef.current.value])}  onChange={handleSelection} list='searchInventoryProduct_StockProductItemsList' autocomplete='off' required></input>
                                        <datalist id='searchInventoryProduct_StockProductItemsList'>
                                            {searchResults.map((result) => (
                                                <option key={result.db_itemId} value={result.db_itemName}></option>
                                            ))}
                                        </datalist>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol>
                                        <IonItem>
                                            <IonLabel>Quantity Added: </IonLabel>
                                            <IonInput type='number' placeholder='Enter Qty' onIonChange={handleQuantityAddedToProduct}></IonInput>                        
                                        </IonItem>  
                                    </IonCol>
                                </IonRow>
                                </IonGrid>

                        </IonHeader>
                                {viewItemDetailsData.map((detailData) =>   {
                                return (
                                <IonGrid >
                                <IonRow >
                                    <IonCol >itemID</IonCol>
                                    <IonCol >{detailData.itemID}</IonCol>
                                    <IonCol >
                                        <IonButton > Update </IonButton>
                                    </IonCol>
                                </IonRow>
                                <IonRow >
                                    <IonCol >itemName</IonCol>
                                    <IonCol >{detailData.itemName}</IonCol>
                                    <IonCol >
                                        <IonButton > Update </IonButton>
                                    </IonCol>
                                </IonRow>
                                <IonRow >
                                    <IonCol >vendorPartNum</IonCol>
                                    <IonCol >{detailData.vendorPartNum}</IonCol>
                                    <IonCol >
                                        <IonButton > Update </IonButton>
                                    </IonCol>
                                </IonRow>
                                <IonRow >
                                    <IonCol >vendorName</IonCol>
                                    <IonCol >{detailData.vendorName}</IonCol>
                                    <IonCol >
                                        <IonButton > Update </IonButton>
                                    </IonCol>
                                </IonRow>
                                <IonRow >
                                    <IonCol >Cost Per Unit</IonCol>
                                    <IonCol >{detailData.costPerUnit}</IonCol>
                                    <IonCol >
                                        <IonButton > Update </IonButton>
                                    </IonCol>
                                </IonRow>
                                <IonRow >
                                    <IonCol >qtyInStock</IonCol>
                                    <IonCol >{detailData.qtyInStock}</IonCol>
                                    <IonCol >
                                        <IonButton > Update </IonButton>
                                    </IonCol>
                                </IonRow>
                                <IonRow >
                                    <IonCol >qtyInUse</IonCol>
                                    <IonCol >{detailData.qtyInUse}</IonCol>
                                    <IonCol >
                                        <IonButton > Update </IonButton>
                                    </IonCol>
                                </IonRow>
                                <IonRow >
                                    <IonCol size='4'>Replenish</IonCol>
                                    <IonCol size='4'>
                                        <IonInput type='number' placeholder='Enter Qty' onIonChange={handleQuantityAddedToProduct}></IonInput>                        
                                    </IonCol>
                                    <IonCol size='4'>
                                        <IonButton onClick={() => stockProductItems_online(detailData.itemID)}> Confirm </IonButton>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                                )})}

                    <IonButton className='button_closeModal_center' onClick={() => setStockInventoryProductModal_online(false)}>Cancel </IonButton>

                </IonModal>

                <IonModal id='stockInventoryProductModal_onSite' isOpen={ stockInventoryProductModal_onSite}>
                        <IonHeader>

                            <IonGrid >
                                <IonRow>
                                    <IonCol>
                                        <label for='searchInventoryProduct_StockProductItems'>Search Inventory Item for Hotel Product:</label>
                                        <input type='text' id='searchInventoryProduct_StockProductItems' ref={ productItemNameRef } placeholder='Search Product Item' onInput={() => handleInput(['stock_product_item', productItemNameRef.current.value])}  onChange={handleSelection} list='searchInventoryProduct_StockProductItemsList' autocomplete='off' required></input>
                                        <datalist id='searchInventoryProduct_StockProductItemsList'>
                                            {searchResults.map((result) => (
                                                <option key={result.db_itemId} value={result.db_itemName}></option>
                                            ))}
                                        </datalist>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol>
                                        <IonItem>
                                            <IonLabel>Quantity Added: </IonLabel>
                                            <IonInput type='number' placeholder='Enter Qty' onIonChange={handleQuantityAddedToProduct}></IonInput>                        
                                        </IonItem>  
                                    </IonCol>
                                </IonRow>
                                </IonGrid>

                        </IonHeader>
                                {viewItemDetailsData.map((detailData) =>   {
                                return (
                                <IonGrid >
                                <IonRow >
                                    <IonCol >itemID</IonCol>
                                    <IonCol >{detailData.itemID}</IonCol>
                                    <IonCol >
                                        <IonButton > Update </IonButton>
                                    </IonCol>
                                </IonRow>
                                <IonRow >
                                    <IonCol >itemName</IonCol>
                                    <IonCol >{detailData.itemName}</IonCol>
                                    <IonCol >
                                        <IonButton > Update </IonButton>
                                    </IonCol>
                                </IonRow>
                                <IonRow >
                                    <IonCol >vendorPartNum</IonCol>
                                    <IonCol >{detailData.vendorPartNum}</IonCol>
                                    <IonCol >
                                        <IonButton > Update </IonButton>
                                    </IonCol>
                                </IonRow>
                                <IonRow >
                                    <IonCol >vendorName</IonCol>
                                    <IonCol >{detailData.vendorName}</IonCol>
                                    <IonCol >
                                        <IonButton > Update </IonButton>
                                    </IonCol>
                                </IonRow>
                                <IonRow >
                                    <IonCol >Cost Per Unit</IonCol>
                                    <IonCol >{detailData.costPerUnit}</IonCol>
                                    <IonCol >
                                        <IonButton > Update </IonButton>
                                    </IonCol>
                                </IonRow>
                                <IonRow >
                                    <IonCol >qtyInStock</IonCol>
                                    <IonCol >{detailData.qtyInStock}</IonCol>
                                    <IonCol >
                                        <IonButton > Update </IonButton>
                                    </IonCol>
                                </IonRow>
                                <IonRow >
                                    <IonCol >qtyInUse</IonCol>
                                    <IonCol >{detailData.qtyInUse}</IonCol>
                                    <IonCol >
                                        <IonButton > Update </IonButton>
                                    </IonCol>
                                </IonRow>
                                <IonRow >
                                    <IonCol size='4'>Replenish</IonCol>
                                    <IonCol size='4'>
                                        <IonInput type='number' placeholder='Enter Qty' onIonChange={handleQuantityAddedToProduct}></IonInput>                        
                                    </IonCol>
                                    <IonCol size='4'>
                                        <IonButton onClick={() => stockProductItems_onSite(detailData.itemID)}> Confirm </IonButton>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                                )})}

                    <IonButton className='button_closeModal_center' onClick={() => setStockInventoryProductModal_onSite(false)}>Cancel </IonButton>

                </IonModal>

                <IonModal id='stockInventoryItemModal' isOpen={ stockInventoryItemModal}>
                    <IonSlides pager='true'>
                        <IonSlide>
                            <IonGrid>
                                <IonRow>
                                    <IonCol>
                                        <label for='searchInventoryItem_StockItem'>Search Inventory Item:</label>
                                        <input type='text' id='searchInventoryItem_StockItem' ref={ itemNameRef } placeholder='Search Inventory Items To Stock' onInput={() => handleInput(['stock_item', itemNameRef.current.value])} list='searchInventoryItem_StockItemList' autocomplete='off' required></input>
                                        <datalist id='searchInventoryItem_StockItemList'>
                                            {searchResults.map((result) => (
                                                <option key={result.db_itemId} value={result.db_itemName}></option>
                                            ))}
                                        </datalist>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol>
                                        <IonItem>
                                            <IonLabel>Quantity Added: </IonLabel>
                                            <IonInput type='number' placeholder='Enter Qty' onIonChange={handleQuantityReplenish}></IonInput>                        
                                        </IonItem>    
                                    </IonCol>
                                </IonRow>
                            </IonGrid>                    
                        </IonSlide>
                    </IonSlides>

                    <IonButton className='modal_footer_button_left' onClick={() => setShowPasswordModalHandler([true, 'replenish-s'])}> Confirm Replenish Stock </IonButton> 
                    <IonButton className='modal_footer_button_right' onClick={() => setStockInventoryItemModal(false)}>Cancel </IonButton>

                </IonModal>

                <IonModal id='deleteInventoryItemModal' isOpen={ deleteInventoryItemModal}>
                    <IonSlides pager='true'>
                        <IonSlide>
                            <IonGrid>
                                <IonRow>
                                    <IonCol>
                                        <label for='searchInventoryItem_deleteItem'>Search Products For Deletion </label>
                                        <input type='text' id='searchInventoryProduct_DeleteProduct' ref={ itemNameRef } placeholder='Search Inventory Items To Delete' onInput={() => handleInput(['delete_stock_item', itemNameRef.current.value])} list='searchInventoryItem_deleteItemList' autocomplete='off' required></input>
                                        <datalist id='searchInventoryItem_deleteItemList'>
                                            {searchResults.map((result) => (
                                                <option key={result.db_itemId} value={result.db_itemName}></option>
                                            ))}
                                        </datalist>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>

                            <div id='deleteItemGrid' style={{display: 'none'}}>
                            <IonGrid class='gridText'>
                            <IonRow >
                                        <IonCol >Item ID</IonCol>
                                        <IonCol >Item Name</IonCol>
                                        <IonCol >Vendor Part Number</IonCol>
                                        <IonCol >Vendor Name</IonCol>
                                        <IonCol >Cost per Unit</IonCol>
                                        <IonCol >Qty InStock</IonCol>
                                        <IonCol >Qty InUse</IonCol>
                                        <IonCol >Date Replenished</IonCol>
                                </IonRow>
                                {viewItemDetailsData.map((detailData) =>   {
                                    return (
                                        <IonRow >
                                            <IonCol >{detailData.itemID}</IonCol>
                                            <IonCol >{detailData.itemName}</IonCol>
                                            <IonCol >{detailData.vendorPartNum}</IonCol>
                                            <IonCol >{detailData.vendorName}</IonCol>
                                            <IonCol >{detailData.costPerUnit}</IonCol>
                                            <IonCol >{detailData.qtyInStock}</IonCol>
                                            <IonCol >{detailData.qtyInUse}</IonCol>
                                            <IonCol >{detailData.dateReplenished}</IonCol>
                                        </IonRow>
                                    )
                                }
                                )}
                            </IonGrid>
                            </div>

                            <IonButton onClick={() => updateEnterAdminPasswordDeleteItemModal(true)}> Confirm Item Deletion </IonButton>                         
                        </IonSlide>
                    </IonSlides>
                    <IonButton onClick={() => updateDeleteInventoryItemModal(false)}>Cancel </IonButton>
                </IonModal>

                <EnterPasswordModal openModal={ showPasswordModal } closeModal={() => setShowPasswordModal(false)} onSubmitPassword={ onSubmitPasswordHandler }></EnterPasswordModal>



                <IonModal id='enterAdminPasswordDeleteItem' isOpen={ adminPasswordDeleteItemModal}>
                    <IonSlides>
                        <IonSlide>
                            <IonItem> 
                            <h1>Enter Password</h1>
                                <label for='adminPasswordDeleteItem'>Invoice</label>
                                 <IonInput type='text' id='adminPasswordDeleteItem' onIonChange={(e) => handleEnterAdminPassword(e)}></IonInput>
                            </IonItem>
                            <IonButton onClick={() => deleteItem()}> Delete Item </IonButton>                         
                        </IonSlide>
                    </IonSlides>
                    <IonButton onClick={() => updateEnterAdminPasswordDeleteItemModal(false)}>Cancel </IonButton>
                </IonModal>
            </IonContent>
        
            </React.Fragment>

        )
    }   